const SUSPENDED_UNTIL_KEY = '__tsSessionCheckSuspendedUntil';
export const MAX_SESSION_CHECK_SUSPEND_MS = 60 * 1000;
const getWindow = () => {
    return typeof window === 'undefined'
        ? null
        : window;
};
export const suspendSessionChecks = (ttlMs = MAX_SESSION_CHECK_SUSPEND_MS) => {
    const win = getWindow();
    if (!win) {
        return;
    }
    win[SUSPENDED_UNTIL_KEY] =
        Date.now() + Math.min(ttlMs, MAX_SESSION_CHECK_SUSPEND_MS);
};
export const resumeSessionChecks = () => {
    const win = getWindow();
    if (!win) {
        return;
    }
    delete win[SUSPENDED_UNTIL_KEY];
};
export const areSessionChecksSuspended = () => {
    const win = getWindow();
    if (!win) {
        return false;
    }
    const now = Date.now();
    const suspendedUntil = win[SUSPENDED_UNTIL_KEY] ?? 0;
    return (now < suspendedUntil &&
        suspendedUntil - now <= MAX_SESSION_CHECK_SUSPEND_MS);
};
//# sourceMappingURL=session-check-suspend.js.map